/* Vuex mutations types for module App */
import { hToggleArrayItem } from '@/utils/helpers';

import {
  TOGGLE_PENDING_ASYNC_STORE_ACTIONS,
  TOOGLE_SOCKET_CONNECTION,
} from './mutations-types';

export default {
  [TOGGLE_PENDING_ASYNC_STORE_ACTIONS](state, payload) {
    const _state = state;
    _state.pendingAsyncStoreActions = hToggleArrayItem(_state.pendingAsyncStoreActions, payload);
  },
  [TOOGLE_SOCKET_CONNECTION](state, payload) {
    const _state = state;
    _state.stateSocketServer = payload;
  },
};
